import SEO from "@components/seo";
import MainContent from "@components/content";
import Search from "@components/search";
import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import css from './index.module.css';

export default function RootPage() {
  const [categories, setCategories] = useState<any>([]);
  useEffect(() => {
    axios.get(`${import.meta.env.VITE_API_URL}/categories`, {
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(response => {
      setCategories(response.data);
    }).catch(error => {
      console.log(error);
    });
  }, []);

  return (
    <MainContent header={'n'}>    
      <SEO 
        title="Главная"
        description="Магазин"
        ogUrl="https://рыбныимир.рф/"
      />

      <div className={css.header}>
        <h1>Рыбный мир</h1>
        <Search />
      </div>

      <div className={`${css.categories}`}>
        {categories.map((category: any) => (
          <Link to={`/webapp/catalog/${category.id}`} key={category.id} className={css.category}>
            <a>{category.name}</a>
            <i className="fi fi-rr-angle-right"></i>
          </Link>
        ))}
      </div>

    </MainContent>
  )
}